import Container from 'react-bootstrap/esm/Container'
import { Outlet, useNavigate, useParams } from 'react-router-dom'
import { StyledBody, StyledWrapper } from './Home.styled'
import Header from '../Header/Header'
import Navigation from '../Navigation/Navigation'
import './App.scss'
import { useAppSelector } from '../../store/store'
import { useEffect } from 'react'
import { toTitleCase } from '../../utility'
import useChallengeSelector from '../../hooks/useChallengeSelector'

const Home = () => {
  const belts = useAppSelector((store) => store.belt)
  const params = useParams()
  const navigate = useNavigate()
  const challenges = useChallengeSelector(params.activeTab ? Number(belts.nameMap[params.activeTab]) : undefined)
  const storeConfig = useAppSelector((state) => state.config)

  useEffect(() => {
    if (storeConfig.init && !storeConfig.logged_in && params.activeTab === 'user') {
      const redirect = encodeURI(location.href)
      location.assign(`/login/?redirect_to=${redirect}`)
    }
  }, [params.activeTab, storeConfig.init, storeConfig.logged_in])

  useEffect(() => {
    if (!params.activeTab) {
      if (belts.list.length) {
        navigate(belts.idMap[belts.list[0].id], {
          replace: true
        })
      }
    }
  }, [belts.list, belts.idMap, navigate, params.activeTab])

  useEffect(() => {
    if (params.activeTab) {
      const challengeTitle = challenges?.reduce((result, item) => {
        if (item.id === params.activeChallenge) {
          return item.title
        }

        return result
      }, '')

      document.title =
        'Challenge Page - ' + toTitleCase(params.activeTab) + (challengeTitle ? ` - ${challengeTitle}` : ' - Home')
    }
  }, [challenges, params.activeChallenge, params.activeTab])

  return (
    <Container fluid>
      <Header />
      <StyledWrapper className='tab-wrapper'>
        <Navigation />

        <StyledBody>
          <Outlet />
        </StyledBody>
      </StyledWrapper>
    </Container>
  )
}

export default Home
